module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAlCAYAAABCr8kFAAABNUlEQVRIS63VwUoDMRQF0PsQ9Mu6dKug4MYmWYpdCm5cCuJ6GApuFPwHP8ad+Ad2oL2S0pY2nWSSl8l6OCST+24Elcs5NyF5D+C767oHqfGMMRci8gHgxDsk52owxDYb+1KBEWxJ8rwYjGEict00zWcROIT5Y2eDOVg2mItlgSXYIOicuyT5vs3ZJhrL7QX0ZTj6DzVYdIdarBeswY7AWuwAHAPbgWNha9Ba+wTgMYhAMhqpyvPgAsDp3kcrEbnyg67pSg/+ATjbB0netm37pgKdczOSL+GRSU416HpSjDF3IvIatI8vzGJ0N3pjoQezPAZ6VA61aG/b1KDR+tKiyTdFgw4+UqXoIFia0yywBM0Gc9EiMActBlMogBsVmEB/1WAE/akCPWqtnQJ4BrAQEVsNhq3+D/f8D9Xd7FgmAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/common/newBack.png
// module id = 9Rsl
// module chunks = 1